function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M0 0H14V14H0z",
  transform: "translate(-287 -535) translate(267 247) translate(20 287) translate(0 1)"
}), React.createElement("path", {
  fill: "#FFBC5D",
  d: "M7.62.336c-.243-.448-.996-.448-1.238 0l-6.3 11.657c-.116.213-.109.47.018.675.127.207.355.332.6.332h12.6c.246 0 .473-.125.6-.331.127-.207.133-.463.018-.675L7.62.336zM7.7 11.17H6.3v-1.4h1.4v1.4zm-1.4-2.8v-3.5h1.4l.001 3.5h-1.4z",
  transform: "translate(-287 -535) translate(267 247) translate(20 287) translate(0 1)"
})))))));

var SvgActionHistoryAlert = function SvgActionHistoryAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgActionHistoryAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/action_history_alert.8fd0dec4.svg";
export { ForwardRef as ReactComponent };